import './styles.scss';

class DateField {
  init(elem, flatpickr) {
    if (!elem || elem._flatpickr) return;

    const picker = flatpickr.default || flatpickr;
    const appendTo = elem.closest('.js-sm-modal') || document.querySelector('.js-sm-modal') || document.body;

    picker(elem, {...{dateFormat: 'M j, Y',
      appendTo,
      onReady: (selectedDates, dateStr, instance) => {
      elem.dispatchEvent(new CustomEvent('sm-datepicker:inited', {detail: {instance}}));

      if (elem.dataset.mode === 'range') {
        elem.addEventListener('change', () => {
          const dates = elem._flatpickr.selectedDates;
          document.querySelector(elem.dataset.startSelector || '#start_date').value = moment(dates[0]).format('MMM DD, YYYY');
          document.querySelector(elem.dataset.endSelector || '#end_date').value = moment(dates[1]).format('MMM DD, YYYY');
        });
      }
    }}, ...elem.dataset});
  }
}

document.addEventListener('DOMContentLoaded', function() {
  function initCalendars(flatpickr, container = 'body') {
    const roots = typeof container === 'string' ? document.querySelectorAll(container) : [container].filter(Boolean);
    const elements = new Set();

    roots.forEach((root) => {
      if (root.matches?.('.js-sm-flatpickr')) elements.add(root);
      root.querySelectorAll?.('.js-sm-flatpickr').forEach((el) => elements.add(el));
    });

    elements.forEach((el) => {
      new DateField().init(el, flatpickr);
    });
  }

  import('flatpickr')
    .then((flatpickr) => {
      initCalendars(flatpickr);

      document.addEventListener('html-updated', (e) => {
        initCalendars(flatpickr, e.detail ? e.detail.container : undefined);
      });

      document.addEventListener('sm-modal:opened', (e) => {
        initCalendars(flatpickr, e.detail?.modalContainer);
      });
    });
});
